import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';

import AccessoriesListing from 'commons-vehicle/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx';
import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
import FinanceListing from 'commons-vehicle/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx';
import ProtectionsListing from 'commons-vehicle/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25';

import 'commons-vehicle/Quote/components/TransactionSummary/Finance/Finance.scss';

const Finance = ({ purchaseMethods, quoteV25, displayCreditRate }) => {
    const { finance, transaction } = quoteV25;
    const { term, sellingPrice } = finance;
    const protection = transaction ? transaction.filter((item) => item.category === 'protection') : null;
    const option = transaction ? transaction.filter((item) => item.category === 'option') : null;
    const purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    const purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(LocaleService);
    const paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);
    const protectionsPackages = purchaseMethods.getSelectedProtectionsPackages();
    const accessoiresOptionsPackages = purchaseMethods.getSelectedOptions();

    const czGroup = 'widget.checkout';
    const cz = ContentZonesService.getContentZone(czGroup, 'sidebar.selling.price.label');

    const sellingPriceLabel = (cz && cz.getValue()) || LocaleService.t('SUMMARY.SELLING_PRICE');

    return (
        <div className="FinanceSummary">
            <div className="vehicle__salePrice">
                <span className="total-price">
                    <AmountLineItem label={sellingPriceLabel} amount={sellingPrice} />
                </span>
                <ProtectionsListing
                    purchaseMethodLabels={purchaseMethodLabels}
                    protectionsPackages={protectionsPackages}
                    purchaseMethods={purchaseMethods}
                    protection={protection}
                />
            </div>

            <AccessoriesListing
                accessoriesOptions={accessoiresOptionsPackages}
                purchaseMethods={purchaseMethods}
                option={option}
            />

            <FinanceListing
                selectedFinanceTerm={selectedFinanceTerm}
                paymentFrequencyLabels={paymentFrequencyLabels}
                purchaseMethodLabels={purchaseMethodLabels}
                purchaseMethodAmounts={purchaseMethodAmounts}
                term={term}
                displayCreditRate={displayCreditRate}
            />
        </div>
    );
};

Finance.defaultProps = {
    displayCreditRate: false,
};

Finance.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel).isRequired,
    quoteV25: PropTypes.instanceOf(QuoteModelV25).isRequired,
    displayCreditRate: PropTypes.bool,
};

Finance.displayName = 'Finance';

export default Finance;
